import { DateTime, Duration } from "luxon";

import { streamingApi } from "./base.api";
import { DiagnosticLogInfoData } from "features/diagnostics/types/DiagnosticsData";

const BASE_PATH = "/diagnostics";

export const diagnosticsApi = streamingApi.injectEndpoints({
    endpoints: (build) => ({
        getStreamDiagnosticsForOperation: build.query<
            DiagnosticLogInfoData,
            {
                lookbackDuration: string;
                diagnosticsCorrelationId?: string;
            }
        >({
            query: (args) => {
                const queryFrom = DateTime.now()
                    .minus(Duration.fromISO(args.lookbackDuration))
                    .toISO();
                const queryTo = DateTime.now().toISO();

                return {
                    url: `${BASE_PATH}/StreamDiagnostics/?queryFrom=${encodeURIComponent(queryFrom)}&queryTo=${encodeURIComponent(queryTo)}${args.diagnosticsCorrelationId ? `&diagnosticCorrelationId=${encodeURIComponent(args.diagnosticsCorrelationId)}` : ""}`,
                };
            },
        }),
        getCurrentServerTime: build.query<Date, undefined>({
            query: () => {
                return {
                    url: `${BASE_PATH}/StreamDiagnostics/CurrentServerTime`,
                };
            }, // Prevent caching
            keepUnusedDataFor: 0,
            providesTags: [], // No tags, so nothing can invalidate or cache
        }),
    }),
    overrideExisting: true,
});

export const {
    useGetStreamDiagnosticsForOperationQuery,
    useGetCurrentServerTimeQuery,
    useLazyGetCurrentServerTimeQuery,
} = diagnosticsApi;
